var _g, _g2, _g3, _g4, _g5, _path, _path2, _g6, _g7, _path3, _g8, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g9, _path14, _path15, _path16, _g10, _g11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 706,
    viewBox: "0 0 360 706",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_58)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_638_58)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 103.357,
    width: 2,
    height: 21,
    fill: "#8B888F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 103.357,
    width: 2,
    height: 21,
    fill: "url(#paint0_linear_638_58)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_638_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 107.357C7 104.974 5 103.357 5 103.357L10.1056 100.571C11.4354 99.9062 13 100.873 13 102.36V107.357V120.357V125.355C13 126.842 11.4354 127.809 10.1056 127.144L5 124.357C5 124.357 7 122.741 7 120.357V107.357Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 107.357C7 104.974 5 103.357 5 103.357L10.1056 100.571C11.4354 99.9062 13 100.873 13 102.36V107.357V120.357V125.355C13 126.842 11.4354 127.809 10.1056 127.144L5 124.357C5 124.357 7 122.741 7 120.357V107.357Z",
    fill: "url(#paint1_linear_638_58)",
    fillOpacity: 0.9
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_638_58)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_638_58)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 73,
    transform: "matrix(-1 0 0 1 350.627 169.728)",
    fill: "#8B888F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 73,
    transform: "matrix(-1 0 0 1 350.627 169.728)",
    fill: "url(#paint2_linear_638_58)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_638_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.627 173.728C348.627 171.344 350.627 169.728 350.627 169.728L345.521 166.941C344.192 166.276 342.627 167.243 342.627 168.73V173.728V238.728V243.725C342.627 245.212 344.192 246.179 345.521 245.514L350.627 242.728C350.627 242.728 348.627 241.111 348.627 238.728V173.728Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.627 173.728C348.627 171.344 350.627 169.728 350.627 169.728L345.521 166.941C344.192 166.276 342.627 167.243 342.627 168.73V173.728V238.728V243.725C342.627 245.212 344.192 246.179 345.521 245.514L350.627 242.728C350.627 242.728 348.627 241.111 348.627 238.728V173.728Z",
    fill: "url(#paint3_linear_638_58)",
    fillOpacity: 0.9
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_638_58)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_638_58)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 153.735,
    width: 2,
    height: 43,
    fill: "#8B888F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 153.735,
    width: 2,
    height: 43,
    fill: "url(#paint4_linear_638_58)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_638_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 157.735C7 155.351 5 153.735 5 153.735L10.1056 150.949C11.4354 150.284 13 151.251 13 152.738V157.735V192.735V197.733C13 199.22 11.4354 200.187 10.1056 199.522L5 196.735C5 196.735 7 195.119 7 192.735V157.735Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 157.735C7 155.351 5 153.735 5 153.735L10.1056 150.949C11.4354 150.284 13 151.251 13 152.738V157.735V192.735V197.733C13 199.22 11.4354 200.187 10.1056 199.522L5 196.735C5 196.735 7 195.119 7 192.735V157.735Z",
    fill: "url(#paint5_linear_638_58)",
    fillOpacity: 0.9
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_638_58)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_638_58)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 217.706,
    width: 2,
    height: 43,
    fill: "#8B888F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 217.706,
    width: 2,
    height: 43,
    fill: "url(#paint6_linear_638_58)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_638_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 221.706C7 219.322 5 217.706 5 217.706L10.1056 214.92C11.4354 214.255 13 215.222 13 216.709V221.706V256.706V261.703C13 263.19 11.4354 264.157 10.1056 263.492L5 260.706C5 260.706 7 259.09 7 256.706V221.706Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 221.706C7 219.322 5 217.706 5 217.706L10.1056 214.92C11.4354 214.255 13 215.222 13 216.709V221.706V256.706V261.703C13 263.19 11.4354 264.157 10.1056 263.492L5 260.706C5 260.706 7 259.09 7 256.706V221.706Z",
    fill: "url(#paint7_linear_638_58)",
    fillOpacity: 0.9
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_ii_638_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.206 72.2309C348.221 75.002 348.221 77.7693 348.221 80.5404V625.545C348.221 628.316 348.221 631.083 348.206 633.855C348.19 636.185 348.163 638.52 348.101 640.85C347.965 645.932 347.663 651.057 346.76 656.082C345.841 661.183 344.341 665.933 341.973 670.567C339.648 675.12 336.613 679.283 332.989 682.893C329.365 686.51 325.19 689.536 320.621 691.855C315.977 694.213 311.218 695.708 306.105 696.625C301.063 697.525 295.923 697.83 290.826 697.966C288.485 698.027 286.148 698.055 283.807 698.07C281.032 698.085 278.253 698.085 275.474 698.085H195.429C194.876 697.129 193.842 696.486 192.658 696.486H162.969C161.785 696.486 160.751 697.129 160.198 698.085H80.1533C77.3781 698.085 74.5991 698.085 71.8239 698.07C69.4828 698.055 67.1418 698.027 64.8046 697.966C59.7077 697.83 54.5643 697.525 49.5256 696.625C44.4132 695.708 39.6536 694.213 35.0102 691.855C30.4405 689.536 26.2622 686.51 22.6421 682.893C19.0181 679.283 15.9832 675.12 13.6577 670.567C11.2895 665.933 9.78947 661.183 8.87087 656.082C7.96777 651.057 7.66545 645.932 7.52979 640.85C7.46778 638.52 7.43677 636.185 7.42514 633.855C7.40576 631.083 7.40576 628.316 7.40576 625.545V80.5404C7.40576 77.7693 7.40576 75.002 7.42514 72.2309C7.43677 69.9003 7.46778 67.5659 7.52979 65.2354C7.66545 60.153 7.96777 55.0282 8.87087 50.0038C9.78947 44.9021 11.2895 40.156 13.6577 35.522C15.9832 30.9653 19.0181 26.8028 22.6421 23.1891C26.2622 19.5793 30.4405 16.5492 35.0102 14.2302C39.6536 11.8726 44.4132 10.3769 49.5256 9.46093C54.5643 8.55655 59.7077 8.25895 64.8046 8.11981C67.1418 8.05797 69.4828 8.03092 71.8239 8.01546C74.5991 8 77.3781 8 80.1533 8H167.215C169.994 8 172.773 8 175.548 8.01546C176.304 8.02045 177.06 8.02665 177.815 8.03485C178.571 8.02665 179.327 8.02045 180.083 8.01546C182.858 8 185.637 8 188.412 8H275.474C278.253 8 281.032 8 283.807 8.01546C286.148 8.03092 288.485 8.05797 290.826 8.11981C295.923 8.25895 301.063 8.55655 306.105 9.46093C311.218 10.3769 315.977 11.8726 320.621 14.2302C325.19 16.5492 329.365 19.5793 332.989 23.1891C336.613 26.8028 339.648 30.9653 341.973 35.522C344.341 40.156 345.841 44.9021 346.76 50.0038C347.663 55.0282 347.965 60.153 348.101 65.2354C348.163 67.5659 348.19 69.9003 348.206 72.2309Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.206 72.2309C348.221 75.002 348.221 77.7693 348.221 80.5404V625.545C348.221 628.316 348.221 631.083 348.206 633.855C348.19 636.185 348.163 638.52 348.101 640.85C347.965 645.932 347.663 651.057 346.76 656.082C345.841 661.183 344.341 665.933 341.973 670.567C339.648 675.12 336.613 679.283 332.989 682.893C329.365 686.51 325.19 689.536 320.621 691.855C315.977 694.213 311.218 695.708 306.105 696.625C301.063 697.525 295.923 697.83 290.826 697.966C288.485 698.027 286.148 698.055 283.807 698.07C281.032 698.085 278.253 698.085 275.474 698.085H195.429C194.876 697.129 193.842 696.486 192.658 696.486H162.969C161.785 696.486 160.751 697.129 160.198 698.085H80.1533C77.3781 698.085 74.5991 698.085 71.8239 698.07C69.4828 698.055 67.1418 698.027 64.8046 697.966C59.7077 697.83 54.5643 697.525 49.5256 696.625C44.4132 695.708 39.6536 694.213 35.0102 691.855C30.4405 689.536 26.2622 686.51 22.6421 682.893C19.0181 679.283 15.9832 675.12 13.6577 670.567C11.2895 665.933 9.78947 661.183 8.87087 656.082C7.96777 651.057 7.66545 645.932 7.52979 640.85C7.46778 638.52 7.43677 636.185 7.42514 633.855C7.40576 631.083 7.40576 628.316 7.40576 625.545V80.5404C7.40576 77.7693 7.40576 75.002 7.42514 72.2309C7.43677 69.9003 7.46778 67.5659 7.52979 65.2354C7.66545 60.153 7.96777 55.0282 8.87087 50.0038C9.78947 44.9021 11.2895 40.156 13.6577 35.522C15.9832 30.9653 19.0181 26.8028 22.6421 23.1891C26.2622 19.5793 30.4405 16.5492 35.0102 14.2302C39.6536 11.8726 44.4132 10.3769 49.5256 9.46093C54.5643 8.55655 59.7077 8.25895 64.8046 8.11981C67.1418 8.05797 69.4828 8.03092 71.8239 8.01546C74.5991 8 77.3781 8 80.1533 8H167.215C169.994 8 172.773 8 175.548 8.01546C176.304 8.02045 177.06 8.02665 177.815 8.03485C178.571 8.02665 179.327 8.02045 180.083 8.01546C182.858 8 185.637 8 188.412 8H275.474C278.253 8 281.032 8 283.807 8.01546C286.148 8.03092 288.485 8.05797 290.826 8.11981C295.923 8.25895 301.063 8.55655 306.105 9.46093C311.218 10.3769 315.977 11.8726 320.621 14.2302C325.19 16.5492 329.365 19.5793 332.989 23.1891C336.613 26.8028 339.648 30.9653 341.973 35.522C344.341 40.156 345.841 44.9021 346.76 50.0038C347.663 55.0282 347.965 60.153 348.101 65.2354C348.163 67.5659 348.19 69.9003 348.206 72.2309Z",
    fill: "url(#paint8_linear_638_58)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.206 72.2309C348.221 75.002 348.221 77.7693 348.221 80.5404V625.545C348.221 628.316 348.221 631.083 348.206 633.855C348.19 636.185 348.163 638.52 348.101 640.85C347.965 645.932 347.663 651.057 346.76 656.082C345.841 661.183 344.341 665.933 341.973 670.567C339.648 675.12 336.613 679.283 332.989 682.893C329.365 686.51 325.19 689.536 320.621 691.855C315.977 694.213 311.218 695.708 306.105 696.625C301.063 697.525 295.923 697.83 290.826 697.966C288.485 698.027 286.148 698.055 283.807 698.07C281.032 698.085 278.253 698.085 275.474 698.085H195.429C194.876 697.129 193.842 696.486 192.658 696.486H162.969C161.785 696.486 160.751 697.129 160.198 698.085H80.1533C77.3781 698.085 74.5991 698.085 71.8239 698.07C69.4828 698.055 67.1418 698.027 64.8046 697.966C59.7077 697.83 54.5643 697.525 49.5256 696.625C44.4132 695.708 39.6536 694.213 35.0102 691.855C30.4405 689.536 26.2622 686.51 22.6421 682.893C19.0181 679.283 15.9832 675.12 13.6577 670.567C11.2895 665.933 9.78947 661.183 8.87087 656.082C7.96777 651.057 7.66545 645.932 7.52979 640.85C7.46778 638.52 7.43677 636.185 7.42514 633.855C7.40576 631.083 7.40576 628.316 7.40576 625.545V80.5404C7.40576 77.7693 7.40576 75.002 7.42514 72.2309C7.43677 69.9003 7.46778 67.5659 7.52979 65.2354C7.66545 60.153 7.96777 55.0282 8.87087 50.0038C9.78947 44.9021 11.2895 40.156 13.6577 35.522C15.9832 30.9653 19.0181 26.8028 22.6421 23.1891C26.2622 19.5793 30.4405 16.5492 35.0102 14.2302C39.6536 11.8726 44.4132 10.3769 49.5256 9.46093C54.5643 8.55655 59.7077 8.25895 64.8046 8.11981C67.1418 8.05797 69.4828 8.03092 71.8239 8.01546C74.5991 8 77.3781 8 80.1533 8H167.215C169.994 8 172.773 8 175.548 8.01546C176.304 8.02045 177.06 8.02665 177.815 8.03485C178.571 8.02665 179.327 8.02045 180.083 8.01546C182.858 8 185.637 8 188.412 8H275.474C278.253 8 281.032 8 283.807 8.01546C286.148 8.03092 288.485 8.05797 290.826 8.11981C295.923 8.25895 301.063 8.55655 306.105 9.46093C311.218 10.3769 315.977 11.8726 320.621 14.2302C325.19 16.5492 329.365 19.5793 332.989 23.1891C336.613 26.8028 339.648 30.9653 341.973 35.522C344.341 40.156 345.841 44.9021 346.76 50.0038C347.663 55.0282 347.965 60.153 348.101 65.2354C348.163 67.5659 348.19 69.9003 348.206 72.2309Z",
    fill: "url(#paint9_radial_638_58)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.206 72.2309C348.221 75.002 348.221 77.7693 348.221 80.5404V625.545C348.221 628.316 348.221 631.083 348.206 633.855C348.19 636.185 348.163 638.52 348.101 640.85C347.965 645.932 347.663 651.057 346.76 656.082C345.841 661.183 344.341 665.933 341.973 670.567C339.648 675.12 336.613 679.283 332.989 682.893C329.365 686.51 325.19 689.536 320.621 691.855C315.977 694.213 311.218 695.708 306.105 696.625C301.063 697.525 295.923 697.83 290.826 697.966C288.485 698.027 286.148 698.055 283.807 698.07C281.032 698.085 278.253 698.085 275.474 698.085H195.429C194.876 697.129 193.842 696.486 192.658 696.486H162.969C161.785 696.486 160.751 697.129 160.198 698.085H80.1533C77.3781 698.085 74.5991 698.085 71.8239 698.07C69.4828 698.055 67.1418 698.027 64.8046 697.966C59.7077 697.83 54.5643 697.525 49.5256 696.625C44.4132 695.708 39.6536 694.213 35.0102 691.855C30.4405 689.536 26.2622 686.51 22.6421 682.893C19.0181 679.283 15.9832 675.12 13.6577 670.567C11.2895 665.933 9.78947 661.183 8.87087 656.082C7.96777 651.057 7.66545 645.932 7.52979 640.85C7.46778 638.52 7.43677 636.185 7.42514 633.855C7.40576 631.083 7.40576 628.316 7.40576 625.545V80.5404C7.40576 77.7693 7.40576 75.002 7.42514 72.2309C7.43677 69.9003 7.46778 67.5659 7.52979 65.2354C7.66545 60.153 7.96777 55.0282 8.87087 50.0038C9.78947 44.9021 11.2895 40.156 13.6577 35.522C15.9832 30.9653 19.0181 26.8028 22.6421 23.1891C26.2622 19.5793 30.4405 16.5492 35.0102 14.2302C39.6536 11.8726 44.4132 10.3769 49.5256 9.46093C54.5643 8.55655 59.7077 8.25895 64.8046 8.11981C67.1418 8.05797 69.4828 8.03092 71.8239 8.01546C74.5991 8 77.3781 8 80.1533 8H167.215C169.994 8 172.773 8 175.548 8.01546C176.304 8.02045 177.06 8.02665 177.815 8.03485C178.571 8.02665 179.327 8.02045 180.083 8.01546C182.858 8 185.637 8 188.412 8H275.474C278.253 8 281.032 8 283.807 8.01546C286.148 8.03092 288.485 8.05797 290.826 8.11981C295.923 8.25895 301.063 8.55655 306.105 9.46093C311.218 10.3769 315.977 11.8726 320.621 14.2302C325.19 16.5492 329.365 19.5793 332.989 23.1891C336.613 26.8028 339.648 30.9653 341.973 35.522C344.341 40.156 345.841 44.9021 346.76 50.0038C347.663 55.0282 347.965 60.153 348.101 65.2354C348.163 67.5659 348.19 69.9003 348.206 72.2309Z",
    fill: "url(#paint10_radial_638_58)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_638_58",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 342,
    height: 691
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.221 166.542V80.5404C348.221 77.7693 348.221 75.002 348.206 72.2309C348.19 69.9003 348.163 67.5659 348.101 65.2354C347.965 60.153 347.663 55.0282 346.76 50.0038C345.841 44.9021 344.341 40.156 341.973 35.522C339.648 30.9653 336.613 26.8028 332.989 23.1891C329.365 19.5793 325.19 16.5492 320.621 14.2302C315.977 11.8726 311.218 10.3769 306.105 9.46093C301.063 8.55655 295.923 8.25895 290.826 8.11981C288.485 8.05797 286.148 8.03092 283.807 8.01546C281.032 8 278.253 8 275.474 8H188.412C185.637 8 182.858 8 180.083 8.01546C179.327 8.02045 178.571 8.02665 177.815 8.03485C177.06 8.02665 176.304 8.02045 175.548 8.01546C172.773 8 169.994 8 167.215 8H80.1533C77.3781 8 74.5991 8 71.8239 8.01546C69.4828 8.03092 67.1418 8.05797 64.8046 8.11981C59.7077 8.25895 54.5643 8.55655 49.5256 9.46093C44.4132 10.3769 39.6536 11.8726 35.0102 14.2302C30.4405 16.5492 26.2622 19.5793 22.6421 23.1891C19.0181 26.8028 15.9832 30.9653 13.6577 35.522C11.2895 40.156 9.78947 44.9021 8.87087 50.0038C7.96777 55.0282 7.66545 60.153 7.52979 65.2354C7.46778 67.5659 7.43677 69.9003 7.42514 72.2309C7.40576 75.002 7.40576 77.7693 7.40576 80.5404V100.972C7.88515 101.248 8.20768 101.765 8.20768 102.357V125.546C8.20768 126.138 7.88515 126.655 7.40576 126.932V150.549C7.88515 150.826 8.20768 151.342 8.20768 151.934V198.313C8.20768 198.905 7.88515 199.422 7.40576 199.699L7.40576 213.72C7.88515 213.997 8.20768 214.514 8.20768 215.106V261.484C8.20768 262.076 7.88515 262.593 7.40576 262.87V625.545C7.40576 628.316 7.40576 631.083 7.42514 633.855C7.43677 636.185 7.46778 638.52 7.52979 640.85C7.66545 645.932 7.96777 651.057 8.87087 656.082C9.78947 661.183 11.2895 665.933 13.6577 670.567C15.9832 675.12 19.0181 679.283 22.6421 682.893C26.2622 686.51 30.4405 689.536 35.0102 691.855C39.6536 694.213 44.4132 695.708 49.5256 696.625C54.5643 697.525 59.7077 697.83 64.8046 697.966C67.1418 698.027 69.4828 698.055 71.8239 698.07C74.5991 698.085 77.3781 698.085 80.1533 698.085H159.576C160.223 697.121 161.326 696.486 162.577 696.486H193.05C194.301 696.486 195.404 697.121 196.051 698.085H275.474C278.253 698.085 281.032 698.085 283.807 698.07C286.148 698.055 288.485 698.027 290.826 697.966C295.923 697.83 301.063 697.525 306.105 696.625C311.218 695.708 315.977 694.213 320.621 691.855C325.19 689.536 329.365 686.51 332.989 682.893C336.613 679.283 339.648 675.12 341.973 670.567C344.341 665.933 345.841 661.183 346.76 656.082C347.663 651.057 347.965 645.932 348.101 640.85C348.163 638.52 348.19 636.185 348.206 633.855C348.221 631.083 348.221 628.316 348.221 625.545V246.077C347.742 245.801 347.419 245.284 347.419 244.692V167.927C347.419 167.335 347.742 166.818 348.221 166.542Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.221 166.542V80.5404C348.221 77.7693 348.221 75.002 348.206 72.2309C348.19 69.9003 348.163 67.5659 348.101 65.2354C347.965 60.153 347.663 55.0282 346.76 50.0038C345.841 44.9021 344.341 40.156 341.973 35.522C339.648 30.9653 336.613 26.8028 332.989 23.1891C329.365 19.5793 325.19 16.5492 320.621 14.2302C315.977 11.8726 311.218 10.3769 306.105 9.46093C301.063 8.55655 295.923 8.25895 290.826 8.11981C288.485 8.05797 286.148 8.03092 283.807 8.01546C281.032 8 278.253 8 275.474 8H188.412C185.637 8 182.858 8 180.083 8.01546C179.327 8.02045 178.571 8.02665 177.815 8.03485C177.06 8.02665 176.304 8.02045 175.548 8.01546C172.773 8 169.994 8 167.215 8H80.1533C77.3781 8 74.5991 8 71.8239 8.01546C69.4828 8.03092 67.1418 8.05797 64.8046 8.11981C59.7077 8.25895 54.5643 8.55655 49.5256 9.46093C44.4132 10.3769 39.6536 11.8726 35.0102 14.2302C30.4405 16.5492 26.2622 19.5793 22.6421 23.1891C19.0181 26.8028 15.9832 30.9653 13.6577 35.522C11.2895 40.156 9.78947 44.9021 8.87087 50.0038C7.96777 55.0282 7.66545 60.153 7.52979 65.2354C7.46778 67.5659 7.43677 69.9003 7.42514 72.2309C7.40576 75.002 7.40576 77.7693 7.40576 80.5404V100.972C7.88515 101.248 8.20768 101.765 8.20768 102.357V125.546C8.20768 126.138 7.88515 126.655 7.40576 126.932V150.549C7.88515 150.826 8.20768 151.342 8.20768 151.934V198.313C8.20768 198.905 7.88515 199.422 7.40576 199.699L7.40576 213.72C7.88515 213.997 8.20768 214.514 8.20768 215.106V261.484C8.20768 262.076 7.88515 262.593 7.40576 262.87V625.545C7.40576 628.316 7.40576 631.083 7.42514 633.855C7.43677 636.185 7.46778 638.52 7.52979 640.85C7.66545 645.932 7.96777 651.057 8.87087 656.082C9.78947 661.183 11.2895 665.933 13.6577 670.567C15.9832 675.12 19.0181 679.283 22.6421 682.893C26.2622 686.51 30.4405 689.536 35.0102 691.855C39.6536 694.213 44.4132 695.708 49.5256 696.625C54.5643 697.525 59.7077 697.83 64.8046 697.966C67.1418 698.027 69.4828 698.055 71.8239 698.07C74.5991 698.085 77.3781 698.085 80.1533 698.085H159.576C160.223 697.121 161.326 696.486 162.577 696.486H193.05C194.301 696.486 195.404 697.121 196.051 698.085H275.474C278.253 698.085 281.032 698.085 283.807 698.07C286.148 698.055 288.485 698.027 290.826 697.966C295.923 697.83 301.063 697.525 306.105 696.625C311.218 695.708 315.977 694.213 320.621 691.855C325.19 689.536 329.365 686.51 332.989 682.893C336.613 679.283 339.648 675.12 341.973 670.567C344.341 665.933 345.841 661.183 346.76 656.082C347.663 651.057 347.965 645.932 348.101 640.85C348.163 638.52 348.19 636.185 348.206 633.855C348.221 631.083 348.221 628.316 348.221 625.545V246.077C347.742 245.801 347.419 245.284 347.419 244.692V167.927C347.419 167.335 347.742 166.818 348.221 166.542Z",
    stroke: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_638_58)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter9_f_638_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1563 25.2186C31.4757 23.7653 25.2455 24.44 19.7691 27.5916C10.7596 32.7765 6.55469 43.0741 8.70532 52.6988C9.3764 43.2304 14.5944 34.2575 23.4535 29.1592C27.7837 26.6673 32.4832 25.3891 37.1563 25.2186Z",
    fill: "black",
    fillOpacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter10_f_638_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3545 677.108C30.6738 678.562 24.4437 677.887 18.9672 674.736C9.95764 669.551 5.75277 659.253 7.9034 649.628C8.5745 659.097 13.7925 668.07 22.6516 673.168C26.9818 675.66 31.6814 676.938 36.3545 677.108Z",
    fill: "black",
    fillOpacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_638_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.966 25.2187C324.646 23.7654 330.876 24.44 336.353 27.5916C345.362 32.7765 349.567 43.0739 347.417 52.6986C346.746 43.2303 341.528 34.2575 332.669 29.1593C328.338 26.6673 323.639 25.3891 318.966 25.2187Z",
    fill: "black",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_638_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.367 677.108C325.047 678.562 331.277 677.887 336.754 674.735C345.763 669.551 349.968 659.253 347.818 649.629C347.147 659.097 341.929 668.07 333.069 673.168C328.739 675.66 324.04 676.938 319.367 677.108Z",
    fill: "black",
    fillOpacity: 0.9
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_ddddi_638_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0192 76.6328V629.453C13.0192 631.861 13.0192 634.266 13.036 636.674C13.0461 638.699 13.0731 640.727 13.127 642.753C13.2449 647.169 13.5076 651.622 14.2923 655.988C15.0906 660.422 16.394 664.549 18.4519 668.576C20.4727 672.532 23.1099 676.149 26.259 679.286C29.4048 682.43 33.0356 685.059 37.0065 687.074C41.0414 689.123 45.1774 690.423 49.6199 691.219C53.9984 692.001 58.4678 692.267 62.8968 692.384C64.9277 692.438 66.962 692.461 68.9963 692.475C71.4079 692.488 73.8228 692.488 76.2343 692.488H131.771H224.257H279.393C281.808 692.488 284.223 692.488 286.634 692.475C288.668 692.461 290.699 692.438 292.734 692.384C297.163 692.267 301.629 692.001 306.01 691.219C310.453 690.423 314.589 689.123 318.624 687.074C322.595 685.059 326.222 682.43 329.371 679.286C332.521 676.149 335.158 672.532 337.179 668.576C339.236 664.549 340.54 660.422 341.338 655.988C342.123 651.622 342.386 647.169 342.503 642.753C342.557 640.727 342.581 638.699 342.594 636.674C342.608 634.266 342.608 631.861 342.608 629.453V76.6328C342.608 74.2247 342.608 71.8201 342.594 69.412C342.581 67.3869 342.557 65.3584 342.503 63.3332C342.386 58.9168 342.123 54.4635 341.338 50.0975C340.54 45.6643 339.236 41.5401 337.179 37.5133C335.158 33.5537 332.521 29.9366 329.371 26.7964C326.222 23.6596 322.595 21.0266 318.624 19.0115C314.589 16.9628 310.453 15.6631 306.01 14.8672C301.629 14.0813 297.163 13.8227 292.734 13.7018C290.699 13.648 288.668 13.6245 286.634 13.6111C284.223 13.5977 281.808 13.5977 279.393 13.5977H76.2343C73.8228 13.5977 71.4079 13.5977 68.9963 13.6111C66.962 13.6245 64.9277 13.648 62.8968 13.7018C58.4678 13.8227 53.9984 14.0813 49.6199 14.8672C45.1774 15.6631 41.0414 16.9628 37.0065 19.0115C33.0356 21.0266 29.4048 23.6596 26.259 26.7964C23.1099 29.9366 20.4727 33.5537 18.4519 37.5133C16.394 41.5401 15.0906 45.6643 14.2923 50.0975C13.5076 54.4635 13.2449 58.9168 13.127 63.3332C13.0731 65.3584 13.0461 67.3869 13.036 69.412C13.0192 71.8201 13.0192 74.2247 13.0192 76.6328Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.036 636.667L14.036 636.669C14.0461 638.688 14.073 640.71 14.1266 642.726C14.244 647.125 14.5051 651.519 15.2765 655.811C16.0596 660.16 17.3348 664.192 19.3423 668.121L18.4519 668.576L19.3424 668.121C21.3153 671.983 23.8901 675.515 26.9648 678.578L26.9659 678.579C30.0368 681.647 33.5817 684.215 37.4592 686.183C41.3963 688.182 45.4372 689.453 49.7963 690.234C54.1009 691.004 58.512 691.267 62.9233 691.384C64.9446 691.438 66.9715 691.461 69.0029 691.475C71.4109 691.488 73.8227 691.488 76.2343 691.488H131.771H224.257H279.393C281.808 691.488 284.22 691.488 286.627 691.475C288.659 691.461 290.682 691.438 292.707 691.384C297.118 691.267 301.526 691.004 305.835 690.234M14.036 636.667L306.01 691.219M14.036 636.667C14.0192 634.263 14.0192 631.862 14.0192 629.453V76.6328C14.0192 74.2242 14.0192 71.823 14.036 69.419L14.036 69.417C14.0461 67.3973 14.073 65.3762 14.1266 63.3599C14.244 58.9608 14.5051 54.5665 15.2765 50.2747L14.2923 50.0975M14.036 636.667L15.2765 50.2744M305.835 690.234L306.01 691.219M305.835 690.234C305.835 690.234 305.834 690.234 305.834 690.234L306.01 691.219M305.835 690.234C310.194 689.453 314.234 688.182 318.171 686.183C322.048 684.215 325.59 681.648 328.665 678.578L328.666 678.578C331.74 675.515 334.315 671.983 336.288 668.121L337.179 668.576M306.01 691.219C310.453 690.423 314.589 689.123 318.624 687.074C322.595 685.059 326.222 682.43 329.371 679.286C332.521 676.149 335.158 672.532 337.179 668.576M337.179 668.576L336.288 668.121C338.296 664.192 339.571 660.16 340.354 655.811C341.125 651.519 341.386 647.125 341.504 642.726C341.557 640.71 341.581 638.689 341.594 636.667M337.179 668.576C339.236 664.549 340.54 660.422 341.338 655.988C342.123 651.622 342.386 647.169 342.503 642.753C342.557 640.727 342.581 638.699 342.594 636.674M341.594 636.667L13.036 636.674C13.0192 634.266 13.0192 631.861 13.0192 629.453V76.6328C13.0192 74.2247 13.0192 71.8201 13.036 69.412C13.0461 67.3869 13.0731 65.3584 13.127 63.3332C13.2449 58.9168 13.5076 54.4635 14.2923 50.0975M341.594 636.667L342.594 636.674M341.594 636.667C341.594 636.667 341.594 636.668 341.594 636.668L342.594 636.674M342.594 636.674C342.608 634.266 342.608 631.861 342.608 629.453V76.6328C342.608 74.2247 342.608 71.8201 342.594 69.412C342.581 67.3869 342.557 65.3584 342.503 63.3332C342.386 58.9168 342.123 54.4635 341.338 50.0975M341.338 50.0975C340.54 45.6643 339.236 41.5401 337.179 37.5133C335.158 33.5537 332.521 29.9366 329.371 26.7964M341.338 50.0975L340.354 50.2747C340.354 50.2746 340.354 50.2745 340.354 50.2744M341.338 50.0975L340.354 50.2744M329.371 26.7964C326.222 23.6596 322.595 21.0266 318.624 19.0115C314.589 16.9628 310.453 15.6631 306.01 14.8672M329.371 26.7964L328.665 27.5046C328.665 27.5047 328.666 27.5048 328.666 27.5049M329.371 26.7964L328.666 27.5049M306.01 14.8672C301.629 14.0813 297.163 13.8227 292.734 13.7018M306.01 14.8672L305.834 15.8515C301.527 15.0789 297.12 14.8219 292.707 14.7014M306.01 14.8672L305.834 15.8515C310.193 16.6325 314.234 17.9042 318.171 19.9032L318.171 19.9033C322.048 21.8705 325.59 24.4415 328.666 27.5049M292.734 13.7018C290.699 13.648 288.668 13.6245 286.634 13.6111M292.734 13.7018L292.706 14.7014C292.706 14.7014 292.707 14.7014 292.707 14.7014M292.734 13.7018L292.707 14.7014C292.707 14.7014 292.707 14.7014 292.707 14.7014M286.634 13.6111C284.223 13.5977 281.808 13.5977 279.393 13.5977H76.2343C73.8228 13.5977 71.4079 13.5977 68.9963 13.6111M286.634 13.6111L286.627 14.6111C286.628 14.6111 286.628 14.6111 286.628 14.6111M286.634 13.6111L286.628 14.6111C286.628 14.6111 286.628 14.6111 286.628 14.6111M68.9963 13.6111C66.962 13.6245 64.9277 13.648 62.8968 13.7018M68.9963 13.6111L69.0019 14.6111C69.0021 14.6111 69.0023 14.6111 69.0025 14.6111M68.9963 13.6111L69.0029 14.6111C69.0028 14.6111 69.0027 14.6111 69.0025 14.6111M62.8968 13.7018C58.4678 13.8227 53.9984 14.0813 49.6199 14.8672C45.1774 15.6631 41.0414 16.9628 37.0065 19.0115C33.0356 21.0266 29.4048 23.6596 26.259 26.7964C23.1099 29.9366 20.4727 33.5537 18.4519 37.5133C16.394 41.5401 15.0906 45.6643 14.2923 50.0975M62.8968 13.7018L62.9241 14.7014C62.9239 14.7014 62.9236 14.7014 62.9234 14.7014M62.8968 13.7018L62.9232 14.7014C58.5103 14.8219 54.1004 15.079 49.7966 15.8514L49.7963 15.8515C45.4372 16.6325 41.3963 17.9042 37.4592 19.9032L37.459 19.9033C33.582 21.8707 30.0368 24.4417 26.9651 27.5046C23.8902 30.5708 21.3154 34.1024 19.3426 37.9679L19.3423 37.9684C17.3347 41.8968 16.0597 45.9253 15.2765 50.2744M14.2923 50.0975L15.2765 50.2744M15.2765 50.2744L62.9234 14.7014M62.9234 14.7014C64.9446 14.6479 66.9713 14.6245 69.0025 14.6111M62.9234 14.7014L341.504 63.3598C341.386 58.9607 341.125 54.5663 340.354 50.2744M69.0025 14.6111C71.4106 14.5977 73.8225 14.5977 76.2343 14.5977H279.393C281.808 14.5977 284.22 14.5977 286.628 14.6111M286.628 14.6111C288.659 14.6245 290.682 14.6479 292.707 14.7014M328.666 27.5049C331.74 30.5711 334.315 34.1025 336.288 37.9679L336.288 37.9684C338.296 41.8968 339.571 45.9254 340.354 50.2744",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeWidth: 2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0192 73.5703H7.40576V78.3681H13.0192V73.5703ZM13.0192 618.122H7.40576V622.92H13.0192V618.122ZM342.608 73.5703H348.221V78.3681H342.608V73.5703ZM348.221 618.122H342.608V622.92H348.221V618.122Z",
    fill: "black"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_638_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4249 78.0306V628.054C15.4249 630.424 15.4249 632.791 15.4415 635.16C15.4515 637.153 15.478 639.15 15.531 641.143C15.647 645.489 15.9056 649.872 16.6779 654.168C17.4634 658.531 18.7462 662.593 20.7714 666.556C22.7601 670.45 25.3555 674.009 28.4546 677.096C31.5505 680.19 35.1236 682.778 39.0315 684.761C43.0024 686.777 47.0727 688.056 51.4447 688.839C55.7537 689.61 60.1521 689.871 64.5108 689.986C66.5095 690.039 68.5115 690.062 70.5136 690.076C72.8868 690.089 75.2634 690.089 77.6366 690.089H137.887H218.141H277.99C280.367 690.089 282.744 690.089 285.117 690.076C287.119 690.062 289.118 690.039 291.12 689.986C295.478 689.871 299.873 689.61 304.186 688.839C308.558 688.056 312.628 686.777 316.599 684.761C320.507 682.778 324.077 680.19 327.176 677.096C330.275 674.009 332.87 670.45 334.859 666.556C336.884 662.593 338.167 658.531 338.952 654.168C339.725 649.872 339.983 645.489 340.099 641.143C340.152 639.15 340.176 637.153 340.189 635.16C340.202 632.791 340.202 630.424 340.202 628.054V78.0306C340.202 75.6608 340.202 73.2943 340.189 70.9245C340.176 68.9315 340.152 66.9352 340.099 64.9422C339.983 60.5959 339.725 56.2133 338.952 51.9166C338.167 47.5538 336.884 43.495 334.859 39.5321C332.87 35.6354 330.275 32.0757 327.176 28.9854C324.077 25.8984 320.507 23.3071 316.599 21.324C312.628 19.3079 308.558 18.0288 304.186 17.2454C299.873 16.472 295.478 16.2175 291.12 16.0986C289.118 16.0457 287.119 16.0225 285.117 16.0093C282.744 15.9961 280.367 15.9961 277.99 15.9961H77.6366C75.2634 15.9961 72.8868 15.9961 70.5136 16.0093C68.5115 16.0225 66.5095 16.0457 64.5108 16.0986C60.1521 16.2175 55.7537 16.472 51.4447 17.2454C47.0727 18.0288 43.0024 19.3079 39.0315 21.324C35.1236 23.3071 31.5505 25.8984 28.4546 28.9854C25.3555 32.0757 22.7601 35.6354 20.7714 39.5321C18.7462 43.495 17.4634 47.5538 16.6779 51.9166C15.9056 56.2133 15.647 60.5959 15.531 64.9422C15.478 66.9352 15.4515 68.9315 15.4415 70.9245C15.4249 73.2943 15.4249 75.6608 15.4249 78.0306Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1012 677.45C31.2344 680.581 34.8505 683.2 38.8052 685.207C42.825 687.248 46.9428 688.541 51.3565 689.332C55.7024 690.108 60.13 690.37 64.4976 690.486C66.5011 690.539 68.5068 690.562 70.5103 690.576C72.8856 690.589 75.2636 690.589 77.6366 690.589H137.887H218.141H277.99C280.367 690.589 282.745 690.589 285.12 690.576C287.124 690.562 289.126 690.539 291.133 690.486C295.5 690.37 299.925 690.108 304.274 689.332C308.688 688.541 312.805 687.248 316.825 685.207C320.78 683.2 324.392 680.581 327.529 677.451C330.665 674.326 333.291 670.724 335.304 666.784C337.355 662.771 338.651 658.662 339.445 654.257C340.224 649.923 340.483 645.511 340.599 641.156C340.652 639.158 340.676 637.158 340.689 635.164C340.702 632.792 340.702 630.424 340.702 628.054V78.0306C340.702 75.6611 340.702 73.2932 340.689 70.9217V70.9212C340.676 68.9268 340.652 66.9267 340.599 64.9289C340.483 60.574 340.224 56.1619 339.445 51.8281L338.952 51.9166L339.445 51.828C338.651 47.4232 337.355 43.3166 335.304 39.3046C333.291 35.3609 330.665 31.7586 327.529 28.6313L327.529 28.6311C324.393 25.5074 320.78 22.8851 316.825 20.8781C312.805 18.8372 308.688 17.5441 304.274 16.7533C299.924 15.9732 295.5 15.7179 291.133 15.5987L291.133 15.5987C289.126 15.5457 287.124 15.5226 285.12 15.5093L285.12 15.5093C282.745 15.4961 280.367 15.4961 277.991 15.4961H277.99H77.6366H77.6359C75.2631 15.4961 72.8854 15.4961 70.5108 15.5093L70.5103 15.5093C68.5068 15.5226 66.5011 15.5457 64.4976 15.5987L64.4972 15.5987C60.1306 15.7179 55.7025 15.9732 51.3563 16.7533C46.9428 17.5441 42.825 18.8372 38.8052 20.8781C34.8504 22.8851 31.2345 25.5073 28.1016 28.6313C24.9654 31.7586 22.3389 35.3609 20.3262 39.3046C18.2758 43.3166 16.9789 47.4232 16.1858 51.828L16.1857 51.8281C15.4068 56.1619 15.1474 60.574 15.0312 64.9289L15.0312 64.9289C14.978 66.9261 14.9515 68.926 14.9415 70.9216C14.9249 73.2929 14.9249 75.6607 14.9249 78.0298V78.0306V628.054V628.055C14.9249 630.424 14.9249 632.792 14.9415 635.163C14.9515 637.159 14.978 639.159 15.0312 641.156L15.531 641.143L15.0312 641.156C15.1474 645.511 15.4068 649.923 16.1857 654.257L16.1858 654.257C16.9789 658.662 18.2758 662.771 20.3262 666.784C22.3387 670.724 24.9651 674.326 28.1012 677.45ZM28.1012 677.45L28.4546 677.096M28.1012 677.45C28.1014 677.45 28.1016 677.45 28.1018 677.451L28.4546 677.096M28.4546 677.096C25.3555 674.009 22.7601 670.45 20.7714 666.556H334.859C332.87 670.45 330.275 674.009 327.176 677.096C324.077 680.19 320.507 682.778 316.599 684.761C312.628 686.777 308.558 688.056 304.186 688.839C299.873 689.61 295.478 689.871 291.12 689.986C289.118 690.039 287.119 690.062 285.117 690.076C282.744 690.089 280.367 690.089 277.99 690.089H218.141H137.887H77.6366C75.2634 690.089 72.8868 690.089 70.5136 690.076C68.5115 690.062 66.5095 690.039 64.5108 689.986C60.1521 689.871 55.7537 689.61 51.4447 688.839C47.0727 688.056 43.0024 686.777 39.0315 684.761C35.1236 682.778 31.5505 680.19 28.4546 677.096Z",
    stroke: "black",
    strokeOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.494 39.7004C213.772 39.7004 215.618 37.8592 215.618 35.588C215.618 33.3168 213.772 31.4756 211.494 31.4756C209.216 31.4756 207.37 33.3168 207.37 35.588C207.37 37.8592 209.216 39.7004 211.494 39.7004Z",
    fill: "url(#paint11_linear_638_58)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.494 39.7004C213.772 39.7004 215.618 37.8592 215.618 35.588C215.618 33.3168 213.772 31.4756 211.494 31.4756C209.216 31.4756 207.37 33.3168 207.37 35.588C207.37 37.8592 209.216 39.7004 211.494 39.7004Z",
    fill: "url(#paint12_linear_638_58)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M211.494 40.7004C214.321 40.7004 216.618 38.4142 216.618 35.588C216.618 32.7618 214.321 30.4756 211.494 30.4756C208.667 30.4756 206.37 32.7618 206.37 35.588C206.37 38.4142 208.667 40.7004 211.494 40.7004Z",
    stroke: "url(#paint13_linear_638_58)",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_dii_638_58)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.494 37.9863C212.823 37.9863 213.9 36.9123 213.9 35.5874C213.9 34.2625 212.823 33.1885 211.494 33.1885C210.165 33.1885 209.088 34.2625 209.088 35.5874C209.088 36.9123 210.165 37.9863 211.494 37.9863Z",
    fill: "url(#paint14_linear_638_58)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.494 37.9863C212.823 37.9863 213.9 36.9123 213.9 35.5874C213.9 34.2625 212.823 33.1885 211.494 33.1885C210.165 33.1885 209.088 34.2625 209.088 35.5874C209.088 36.9123 210.165 37.9863 211.494 37.9863Z",
    fill: "url(#paint15_radial_638_58)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.494 37.9863C212.823 37.9863 213.9 36.9123 213.9 35.5874C213.9 34.2625 212.823 33.1885 211.494 33.1885C210.165 33.1885 209.088 34.2625 209.088 35.5874C209.088 36.9123 210.165 37.9863 211.494 37.9863Z",
    fill: "url(#paint16_radial_638_58)",
    fillOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.494 37.9863C212.823 37.9863 213.9 36.9123 213.9 35.5874C213.9 34.2625 212.823 33.1885 211.494 33.1885C210.165 33.1885 209.088 34.2625 209.088 35.5874C209.088 36.9123 210.165 37.9863 211.494 37.9863Z",
    fill: "url(#paint17_radial_638_58)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.494 37.9863C212.823 37.9863 213.9 36.9123 213.9 35.5874C213.9 34.2625 212.823 33.1885 211.494 33.1885C210.165 33.1885 209.088 34.2625 209.088 35.5874C209.088 36.9123 210.165 37.9863 211.494 37.9863Z",
    fill: "url(#paint18_radial_638_58)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.494 37.9863C212.823 37.9863 213.9 36.9123 213.9 35.5874C213.9 34.2625 212.823 33.1885 211.494 33.1885C210.165 33.1885 209.088 34.2625 209.088 35.5874C209.088 36.9123 210.165 37.9863 211.494 37.9863Z",
    fill: "url(#paint19_linear_638_58)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.65 35.5874C213.65 36.7735 212.685 37.7363 211.494 37.7363C210.303 37.7363 209.338 36.7735 209.338 35.5874C209.338 34.4012 210.303 33.4385 211.494 33.4385C212.685 33.4385 213.65 34.4012 213.65 35.5874Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.5,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.494 36.2731C211.874 36.2731 212.181 35.9663 212.181 35.5877C212.181 35.2092 211.874 34.9023 211.494 34.9023C211.115 34.9023 210.807 35.2092 210.807 35.5877C210.807 35.9663 211.115 36.2731 211.494 36.2731Z",
    fill: "white",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "overlay"
    }
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_638_58)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_i_638_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.167 35.588C158.167 34.4839 159.062 33.5889 160.166 33.5889H196.263C197.367 33.5889 198.262 34.4839 198.262 35.588C198.262 36.692 197.367 37.587 196.263 37.587H160.166C159.062 37.587 158.167 36.692 158.167 35.588Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.167 35.588C158.167 34.4839 159.062 33.5889 160.166 33.5889H196.263C197.367 33.5889 198.262 34.4839 198.262 35.588C198.262 36.692 197.367 37.587 196.263 37.587H160.166C159.062 37.587 158.167 36.692 158.167 35.588Z",
    fill: "url(#pattern0)",
    fillOpacity: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.167 35.588C158.167 34.4839 159.062 33.5889 160.166 33.5889H196.263C197.367 33.5889 198.262 34.4839 198.262 35.588C198.262 36.692 197.367 37.587 196.263 37.587H160.166C159.062 37.587 158.167 36.692 158.167 35.588Z",
    fill: "url(#paint20_linear_638_58)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.166 32.5889C158.509 32.5889 157.167 33.9316 157.167 35.588C157.167 37.2443 158.509 38.587 160.166 38.587H196.263C197.92 38.587 199.262 37.2443 199.262 35.588C199.262 33.9316 197.92 32.5889 196.263 32.5889H160.166Z",
    stroke: "url(#paint21_linear_638_58)",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_638_58",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 326,
    height: 676
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4537 634.271V71.0152C27.4537 69.3716 27.4537 67.7303 27.4652 66.0868C27.4721 64.7045 27.4905 63.32 27.5273 61.9377C27.6078 58.9234 27.7871 55.8838 28.3227 52.9038C28.8675 49.878 29.7572 47.0631 31.1618 44.3146C32.5411 41.612 34.341 39.1432 36.4905 36.9999C38.6376 34.8589 41.1157 33.0618 43.826 31.6864C46.58 30.2881 49.403 29.401 52.4352 28.8577C55.4237 28.3213 58.4742 28.1448 61.4972 28.0623C62.8834 28.0256 64.2719 28.0095 65.6604 28.0004C67.3063 27.9912 68.9546 27.9912 70.6006 27.9912H89.2015C91.8559 27.9912 94.0083 30.1346 94.013 32.7804L94.013 32.789L94.013 34.3883C94.013 44.1041 101.912 51.9803 111.655 51.9803H243.972C253.715 51.9803 261.614 44.1041 261.614 34.3883L261.614 32.789C261.614 30.1393 263.768 27.9912 266.426 27.9912H285.026C286.675 27.9912 288.323 27.9912 289.969 28.0004C291.357 28.0095 292.744 28.0256 294.132 28.0623C297.155 28.1448 300.203 28.3213 303.194 28.8577C306.226 29.401 309.049 30.2881 311.803 31.6864C314.514 33.0618 316.99 34.8589 319.139 36.9999C321.288 39.1432 323.088 41.612 324.468 44.3146C325.872 47.0631 326.762 49.878 327.307 52.9038C327.842 55.8838 328.022 58.9234 328.102 61.9377C328.139 63.32 328.155 64.7045 328.164 66.0868C328.173 67.7303 328.173 69.3716 328.173 71.0152V634.271C328.173 635.915 328.173 637.556 328.164 639.2C328.155 640.582 328.139 641.967 328.102 643.349C328.022 646.363 327.842 649.403 327.307 652.383C326.762 655.409 325.872 658.226 324.468 660.974C323.088 663.675 321.288 666.143 319.139 668.284C316.99 670.43 314.514 672.225 311.803 673.6C309.049 674.998 306.226 675.886 303.194 676.429C300.203 676.963 297.155 677.144 294.132 677.224C292.744 677.261 291.357 677.277 289.969 677.286C288.323 677.295 286.675 677.295 285.026 677.295H70.6006C68.9546 677.295 67.3063 677.295 65.6604 677.286C64.2719 677.277 62.8834 677.261 61.4972 677.224C58.4742 677.144 55.4237 676.963 52.4352 676.429C49.403 675.886 46.58 674.998 43.826 673.6C41.1157 672.225 38.6376 670.43 36.4905 668.284C34.341 666.143 32.5411 663.675 31.1618 660.974C29.7572 658.226 28.8675 655.409 28.3227 652.383C27.7871 649.403 27.6078 646.363 27.5273 643.349C27.4905 641.967 27.4721 640.582 27.4652 639.2C27.4537 637.556 27.4537 635.915 27.4537 634.271Z",
    fill: "#252525"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4537 634.271V71.0152C27.4537 69.3716 27.4537 67.7303 27.4652 66.0868C27.4721 64.7045 27.4905 63.32 27.5273 61.9377C27.6078 58.9234 27.7871 55.8838 28.3227 52.9038C28.8675 49.878 29.7572 47.0631 31.1618 44.3146C32.5411 41.612 34.341 39.1432 36.4905 36.9999C38.6376 34.8589 41.1157 33.0618 43.826 31.6864C46.58 30.2881 49.403 29.401 52.4352 28.8577C55.4237 28.3213 58.4742 28.1448 61.4972 28.0623C62.8834 28.0256 64.2719 28.0095 65.6604 28.0004C67.3063 27.9912 68.9546 27.9912 70.6006 27.9912H89.2015C91.8559 27.9912 94.0083 30.1346 94.013 32.7804L94.013 32.789L94.013 34.3883C94.013 44.1041 101.912 51.9803 111.655 51.9803H243.972C253.715 51.9803 261.614 44.1041 261.614 34.3883L261.614 32.789C261.614 30.1393 263.768 27.9912 266.426 27.9912H285.026C286.675 27.9912 288.323 27.9912 289.969 28.0004C291.357 28.0095 292.744 28.0256 294.132 28.0623C297.155 28.1448 300.203 28.3213 303.194 28.8577C306.226 29.401 309.049 30.2881 311.803 31.6864C314.514 33.0618 316.99 34.8589 319.139 36.9999C321.288 39.1432 323.088 41.612 324.468 44.3146C325.872 47.0631 326.762 49.878 327.307 52.9038C327.842 55.8838 328.022 58.9234 328.102 61.9377C328.139 63.32 328.155 64.7045 328.164 66.0868C328.173 67.7303 328.173 69.3716 328.173 71.0152V634.271C328.173 635.915 328.173 637.556 328.164 639.2C328.155 640.582 328.139 641.967 328.102 643.349C328.022 646.363 327.842 649.403 327.307 652.383C326.762 655.409 325.872 658.226 324.468 660.974C323.088 663.675 321.288 666.143 319.139 668.284C316.99 670.43 314.514 672.225 311.803 673.6C309.049 674.998 306.226 675.886 303.194 676.429C300.203 676.963 297.155 677.144 294.132 677.224C292.744 677.261 291.357 677.277 289.969 677.286C288.323 677.295 286.675 677.295 285.026 677.295H70.6006C68.9546 677.295 67.3063 677.295 65.6604 677.286C64.2719 677.277 62.8834 677.261 61.4972 677.224C58.4742 677.144 55.4237 676.963 52.4352 676.429C49.403 675.886 46.58 674.998 43.826 673.6C41.1157 672.225 38.6376 670.43 36.4905 668.284C34.341 666.143 32.5411 663.675 31.1618 660.974C29.7572 658.226 28.8675 655.409 28.3227 652.383C27.7871 649.403 27.6078 646.363 27.5273 643.349C27.4905 641.967 27.4721 640.582 27.4652 639.2C27.4537 637.556 27.4537 635.915 27.4537 634.271Z",
    fill: "url(#pattern1)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_638_58",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 326,
    height: 676
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.425 78.0316V628.055C15.425 630.425 15.425 632.792 15.4415 635.161C15.4515 637.154 15.478 639.151 15.531 641.144C15.647 645.49 15.9056 649.873 16.6779 654.169C17.4634 658.532 18.7462 662.594 20.7714 666.557C22.7602 670.451 25.3555 674.01 28.4546 677.097C31.5505 680.191 35.1236 682.779 39.0315 684.762C43.0024 686.778 47.0727 688.057 51.4447 688.841C55.7537 689.611 60.1521 689.872 64.5108 689.987C66.5095 690.04 68.5116 690.063 70.5136 690.077C72.8868 690.09 75.2634 690.09 77.6367 690.09H137.887H218.141H277.99C280.367 690.09 282.744 690.09 285.117 690.077C287.119 690.063 289.118 690.04 291.12 689.987C295.478 689.872 299.873 689.611 304.186 688.841C308.558 688.057 312.628 686.778 316.599 684.762C320.507 682.779 324.077 680.191 327.176 677.097C330.275 674.01 332.87 670.451 334.859 666.557C336.884 662.594 338.167 658.532 338.953 654.169C339.725 649.873 339.983 645.49 340.099 641.144C340.152 639.151 340.176 637.154 340.189 635.161C340.202 632.792 340.202 630.425 340.202 628.055V78.0316C340.202 75.6618 340.202 73.2953 340.189 70.9255C340.176 68.9325 340.152 66.9362 340.099 64.9432C339.983 60.5969 339.725 56.2143 338.953 51.9175C338.167 47.5547 336.884 43.496 334.859 39.5331C332.87 35.6363 330.275 32.0767 327.176 28.9863C324.077 25.8993 320.507 23.3081 316.599 21.325C312.628 19.3088 308.558 18.0297 304.186 17.2464C299.873 16.473 295.478 16.2185 291.12 16.0995C289.118 16.0466 287.119 16.0235 285.117 16.0103C282.744 15.9971 280.367 15.9971 277.99 15.9971H77.6367C75.2634 15.9971 72.8868 15.9971 70.5136 16.0103C68.5116 16.0235 66.5095 16.0466 64.5108 16.0995C60.1521 16.2185 55.7537 16.473 51.4447 17.2464C47.0727 18.0297 43.0024 19.3088 39.0315 21.325C35.1236 23.3081 31.5505 25.8993 28.4546 28.9863C25.3555 32.0767 22.7602 35.6363 20.7714 39.5331C18.7462 43.496 17.4634 47.5547 16.6779 51.9175C15.9056 56.2143 15.647 60.5969 15.531 64.9432C15.478 66.9362 15.4515 68.9325 15.4415 70.9255C15.425 73.2953 15.425 75.6618 15.425 78.0316Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_638_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0369 56.8372V645.98C21.0369 661.768 31.1032 677.595 30.06 678.696C28.4561 677.896 23.0432 671.499 20.036 664.702C17.431 658.814 15.6254 653.307 15.425 639.713L15.4249 65.375C14.8235 37.1879 32.1518 24.7935 33.2231 25.6735C34.7364 26.9167 21.0369 38.8478 21.0369 56.8372Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0369 56.8372V645.98C21.0369 661.768 31.1032 677.595 30.06 678.696C28.4561 677.896 23.0432 671.499 20.036 664.702C17.431 658.814 15.6254 653.307 15.425 639.713L15.4249 65.375C14.8235 37.1879 32.1518 24.7935 33.2231 25.6735C34.7364 26.9167 21.0369 38.8478 21.0369 56.8372Z",
    fill: "url(#paint22_linear_638_58)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.745 63.6332L336.547 643.98C336.547 650.023 335.619 656.542 333.787 661.502C330.003 671.745 324.663 678.753 325.367 678.695C328.975 675.496 333.587 670.128 336.547 662.702C337.997 658.504 339.801 655.105 340.002 642.911L340.555 63.6333C340.555 52.5387 336.5 35.8848 324.197 26.3722C322.684 25.2021 335.745 45.6439 335.745 63.6332Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.745 63.6332L336.547 643.98C336.547 650.023 335.619 656.542 333.787 661.502C330.003 671.745 324.663 678.753 325.367 678.695C328.975 675.496 333.587 670.128 336.547 662.702C337.997 658.504 339.801 655.105 340.002 642.911L340.555 63.6333C340.555 52.5387 336.5 35.8848 324.197 26.3722C322.684 25.2021 335.745 45.6439 335.745 63.6332Z",
    fill: "url(#paint23_linear_638_58)",
    fillOpacity: 0.8
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_638_58)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.4537,
    y: 27.6475,
    width: 300.72,
    height: 651.158,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 300,
    height: 649,
    rx: 30,
    fill: "url(#paint24_linear_638_58)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.183 632.333L147.29 640H146.135L143.242 632.333H144.309L146.718 638.944L149.127 632.333H150.183ZM156.781 636.755C156.781 636.946 156.77 637.147 156.748 637.36H151.93C151.966 637.954 152.168 638.42 152.535 638.757C152.909 639.087 153.36 639.252 153.888 639.252C154.32 639.252 154.68 639.153 154.966 638.955C155.259 638.75 155.464 638.478 155.582 638.141H156.66C156.498 638.72 156.176 639.193 155.692 639.56C155.208 639.919 154.606 640.099 153.888 640.099C153.316 640.099 152.802 639.971 152.348 639.714C151.9 639.457 151.548 639.094 151.292 638.625C151.035 638.148 150.907 637.598 150.907 636.975C150.907 636.352 151.031 635.805 151.281 635.336C151.53 634.867 151.878 634.507 152.326 634.258C152.78 634.001 153.301 633.873 153.888 633.873C154.46 633.873 154.966 633.998 155.406 634.247C155.846 634.496 156.183 634.841 156.418 635.281C156.66 635.714 156.781 636.205 156.781 636.755ZM155.747 636.546C155.747 636.165 155.662 635.838 155.494 635.567C155.325 635.288 155.094 635.079 154.801 634.94C154.515 634.793 154.196 634.72 153.844 634.72C153.338 634.72 152.905 634.881 152.546 635.204C152.194 635.527 151.992 635.974 151.941 636.546H155.747ZM159.103 634.951C159.279 634.606 159.528 634.339 159.851 634.148C160.181 633.957 160.581 633.862 161.05 633.862V634.896H160.786C159.664 634.896 159.103 635.505 159.103 636.722V640H158.102V633.972H159.103V634.951ZM164.339 640.099C163.877 640.099 163.463 640.022 163.096 639.868C162.73 639.707 162.44 639.487 162.227 639.208C162.015 638.922 161.897 638.596 161.875 638.229H162.909C162.939 638.53 163.078 638.775 163.327 638.966C163.584 639.157 163.918 639.252 164.328 639.252C164.71 639.252 165.01 639.168 165.23 638.999C165.45 638.83 165.56 638.618 165.56 638.361C165.56 638.097 165.443 637.903 165.208 637.778C164.974 637.646 164.611 637.518 164.119 637.393C163.672 637.276 163.305 637.158 163.019 637.041C162.741 636.916 162.499 636.737 162.293 636.502C162.095 636.26 161.996 635.945 161.996 635.556C161.996 635.248 162.088 634.966 162.271 634.709C162.455 634.452 162.715 634.251 163.052 634.104C163.39 633.95 163.775 633.873 164.207 633.873C164.875 633.873 165.414 634.042 165.824 634.379C166.235 634.716 166.455 635.178 166.484 635.765H165.483C165.461 635.45 165.333 635.197 165.098 635.006C164.871 634.815 164.563 634.72 164.174 634.72C163.815 634.72 163.529 634.797 163.316 634.951C163.104 635.105 162.997 635.307 162.997 635.556C162.997 635.754 163.06 635.919 163.184 636.051C163.316 636.176 163.478 636.278 163.668 636.359C163.866 636.432 164.138 636.517 164.482 636.612C164.915 636.729 165.267 636.847 165.538 636.964C165.81 637.074 166.041 637.243 166.231 637.47C166.429 637.697 166.532 637.994 166.539 638.361C166.539 638.691 166.448 638.988 166.264 639.252C166.081 639.516 165.821 639.725 165.483 639.879C165.153 640.026 164.772 640.099 164.339 640.099ZM168.469 632.993C168.279 632.993 168.117 632.927 167.985 632.795C167.853 632.663 167.787 632.502 167.787 632.311C167.787 632.12 167.853 631.959 167.985 631.827C168.117 631.695 168.279 631.629 168.469 631.629C168.653 631.629 168.807 631.695 168.931 631.827C169.063 631.959 169.129 632.12 169.129 632.311C169.129 632.502 169.063 632.663 168.931 632.795C168.807 632.927 168.653 632.993 168.469 632.993ZM168.953 633.972V640H167.952V633.972H168.953ZM173.289 640.099C172.724 640.099 172.211 639.971 171.749 639.714C171.294 639.457 170.935 639.094 170.671 638.625C170.414 638.148 170.286 637.598 170.286 636.975C170.286 636.359 170.418 635.816 170.682 635.347C170.953 634.87 171.32 634.507 171.782 634.258C172.244 634.001 172.761 633.873 173.333 633.873C173.905 633.873 174.422 634.001 174.884 634.258C175.346 634.507 175.709 634.867 175.973 635.336C176.244 635.805 176.38 636.352 176.38 636.975C176.38 637.598 176.24 638.148 175.962 638.625C175.69 639.094 175.32 639.457 174.851 639.714C174.381 639.971 173.861 640.099 173.289 640.099ZM173.289 639.219C173.648 639.219 173.985 639.135 174.301 638.966C174.616 638.797 174.869 638.544 175.06 638.207C175.258 637.87 175.357 637.459 175.357 636.975C175.357 636.491 175.261 636.08 175.071 635.743C174.88 635.406 174.631 635.156 174.323 634.995C174.015 634.826 173.681 634.742 173.322 634.742C172.955 634.742 172.618 634.826 172.31 634.995C172.009 635.156 171.767 635.406 171.584 635.743C171.4 636.08 171.309 636.491 171.309 636.975C171.309 637.466 171.397 637.881 171.573 638.218C171.756 638.555 171.998 638.808 172.299 638.977C172.599 639.138 172.929 639.219 173.289 639.219ZM180.633 633.862C181.366 633.862 181.96 634.086 182.415 634.533C182.869 634.973 183.097 635.611 183.097 636.447V640H182.107V636.59C182.107 635.989 181.956 635.53 181.656 635.215C181.355 634.892 180.944 634.731 180.424 634.731C179.896 634.731 179.474 634.896 179.159 635.226C178.851 635.556 178.697 636.036 178.697 636.667V640H177.696V633.972H178.697V634.83C178.895 634.522 179.162 634.284 179.5 634.115C179.844 633.946 180.222 633.862 180.633 633.862ZM187.983 640.066C187.793 640.066 187.631 640 187.499 639.868C187.367 639.736 187.301 639.575 187.301 639.384C187.301 639.193 187.367 639.032 187.499 638.9C187.631 638.768 187.793 638.702 187.983 638.702C188.167 638.702 188.321 638.768 188.445 638.9C188.577 639.032 188.643 639.193 188.643 639.384C188.643 639.575 188.577 639.736 188.445 639.868C188.321 640 188.167 640.066 187.983 640.066ZM187.983 635.358C187.793 635.358 187.631 635.292 187.499 635.16C187.367 635.028 187.301 634.867 187.301 634.676C187.301 634.485 187.367 634.324 187.499 634.192C187.631 634.06 187.793 633.994 187.983 633.994C188.167 633.994 188.321 634.06 188.445 634.192C188.577 634.324 188.643 634.485 188.643 634.676C188.643 634.867 188.577 635.028 188.445 635.16C188.321 635.292 188.167 635.358 187.983 635.358ZM192.51 632.96V632.047H194.578V640H193.566V632.96H192.51ZM196.781 640.066C196.591 640.066 196.429 640 196.297 639.868C196.165 639.736 196.099 639.575 196.099 639.384C196.099 639.193 196.165 639.032 196.297 638.9C196.429 638.768 196.591 638.702 196.781 638.702C196.965 638.702 197.119 638.768 197.243 638.9C197.375 639.032 197.441 639.193 197.441 639.384C197.441 639.575 197.375 639.736 197.243 639.868C197.119 640 196.965 640.066 196.781 640.066ZM198.607 635.941C198.607 634.68 198.812 633.697 199.223 632.993C199.633 632.282 200.352 631.926 201.379 631.926C202.398 631.926 203.113 632.282 203.524 632.993C203.934 633.697 204.14 634.68 204.14 635.941C204.14 637.224 203.934 638.222 203.524 638.933C203.113 639.644 202.398 640 201.379 640C200.352 640 199.633 639.644 199.223 638.933C198.812 638.222 198.607 637.224 198.607 635.941ZM203.15 635.941C203.15 635.303 203.106 634.764 203.018 634.324C202.937 633.877 202.765 633.517 202.501 633.246C202.244 632.975 201.87 632.839 201.379 632.839C200.88 632.839 200.499 632.975 200.235 633.246C199.978 633.517 199.806 633.877 199.718 634.324C199.637 634.764 199.597 635.303 199.597 635.941C199.597 636.601 199.637 637.155 199.718 637.602C199.806 638.049 199.978 638.409 200.235 638.68C200.499 638.951 200.88 639.087 201.379 639.087C201.87 639.087 202.244 638.951 202.501 638.68C202.765 638.409 202.937 638.049 203.018 637.602C203.106 637.155 203.15 636.601 203.15 635.941ZM205.998 640.066C205.807 640.066 205.646 640 205.514 639.868C205.382 639.736 205.316 639.575 205.316 639.384C205.316 639.193 205.382 639.032 205.514 638.9C205.646 638.768 205.807 638.702 205.998 638.702C206.181 638.702 206.335 638.768 206.46 638.9C206.592 639.032 206.658 639.193 206.658 639.384C206.658 639.575 206.592 639.736 206.46 639.868C206.335 640 206.181 640.066 205.998 640.066ZM207.824 635.941C207.824 634.68 208.029 633.697 208.44 632.993C208.85 632.282 209.569 631.926 210.596 631.926C211.615 631.926 212.33 632.282 212.741 632.993C213.151 633.697 213.357 634.68 213.357 635.941C213.357 637.224 213.151 638.222 212.741 638.933C212.33 639.644 211.615 640 210.596 640C209.569 640 208.85 639.644 208.44 638.933C208.029 638.222 207.824 637.224 207.824 635.941ZM212.367 635.941C212.367 635.303 212.323 634.764 212.235 634.324C212.154 633.877 211.982 633.517 211.718 633.246C211.461 632.975 211.087 632.839 210.596 632.839C210.097 632.839 209.716 632.975 209.452 633.246C209.195 633.517 209.023 633.877 208.935 634.324C208.854 634.764 208.814 635.303 208.814 635.941C208.814 636.601 208.854 637.155 208.935 637.602C209.023 638.049 209.195 638.409 209.452 638.68C209.716 638.951 210.097 639.087 210.596 639.087C211.087 639.087 211.461 638.951 211.718 638.68C211.982 638.409 212.154 638.049 212.235 637.602C212.323 637.155 212.367 636.601 212.367 635.941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 353C218 391.108 187.108 422 149 422C110.892 422 80 391.108 80 353C80 314.892 110.892 284 149 284C187.108 284 218 314.892 218 353Z",
    fill: "white",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.16 335.843H121.235C112.193 335.843 104.84 343.189 104.84 352.281V369.157H139.16V335.843ZM121.235 326C106.746 326 95 337.766 95 352.281V379H149V326H121.235Z",
    fill: "#00C113",
    fillOpacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.355 344.776C130.352 350.438 128.126 356.099 123.711 360.333C119.309 364.554 113.586 366.537 107.953 366.308C107.956 360.646 110.182 354.985 114.597 350.751C118.999 346.53 124.722 344.547 130.355 344.776Z",
    fill: "white",
    fillOpacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.265 330.006V348.586H171.691V337.443L167.492 348.586H163.8L159.574 337.417V348.586H155V330.006H160.403L165.673 342.869L170.889 330.006H176.265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.645 341.175C178.645 339.657 178.93 338.325 179.501 337.178C180.089 336.031 180.883 335.149 181.882 334.532C182.88 333.914 183.995 333.605 185.225 333.605C186.277 333.605 187.196 333.817 187.98 334.24C188.783 334.664 189.398 335.22 189.826 335.908V333.817H194.4V348.586H189.826V346.495C189.38 347.183 188.756 347.739 187.954 348.162C187.169 348.586 186.251 348.797 185.198 348.797C183.986 348.797 182.88 348.489 181.882 347.871C180.883 347.236 180.089 346.345 179.501 345.198C178.93 344.033 178.645 342.692 178.645 341.175ZM189.826 341.201C189.826 340.072 189.505 339.181 188.863 338.528C188.239 337.875 187.472 337.549 186.563 337.549C185.653 337.549 184.877 337.875 184.235 338.528C183.611 339.163 183.299 340.046 183.299 341.175C183.299 342.304 183.611 343.204 184.235 343.874C184.877 344.527 185.653 344.854 186.563 344.854C187.472 344.854 188.239 344.527 188.863 343.874C189.505 343.222 189.826 342.331 189.826 341.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.283 329V348.586H197.709V329H202.283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.172 329V348.586H205.598V329H210.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.225 333.817V348.586H223.651V346.574C223.187 347.227 222.554 347.756 221.752 348.162C220.967 348.55 220.094 348.744 219.131 348.744C217.989 348.744 216.982 348.497 216.108 348.003C215.234 347.492 214.557 346.759 214.075 345.807C213.594 344.854 213.353 343.733 213.353 342.445V333.817H217.9V341.837C217.9 342.825 218.159 343.592 218.676 344.139C219.193 344.686 219.888 344.96 220.762 344.96C221.654 344.96 222.358 344.686 222.875 344.139C223.393 343.592 223.651 342.825 223.651 341.837V333.817H228.225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.368 367.26C167.456 367.489 168.33 368.028 168.99 368.875C169.649 369.704 169.979 370.657 169.979 371.733C169.979 373.286 169.426 374.521 168.321 375.438C167.233 376.338 165.708 376.788 163.747 376.788H155V358.208H163.453C165.361 358.208 166.85 358.641 167.92 359.505C169.007 360.37 169.551 361.543 169.551 363.025C169.551 364.119 169.257 365.028 168.669 365.751C168.098 366.475 167.331 366.978 166.368 367.26ZM159.574 365.725H162.57C163.319 365.725 163.889 365.566 164.282 365.249C164.692 364.913 164.897 364.428 164.897 363.793C164.897 363.158 164.692 362.672 164.282 362.337C163.889 362.002 163.319 361.834 162.57 361.834H159.574V365.725ZM162.944 373.136C163.711 373.136 164.3 372.968 164.71 372.633C165.138 372.28 165.352 371.777 165.352 371.124C165.352 370.471 165.129 369.96 164.683 369.589C164.255 369.219 163.658 369.033 162.891 369.033H159.574V373.136H162.944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.371 362.02V376.788H182.797V374.777C182.333 375.43 181.7 375.959 180.898 376.365C180.113 376.753 179.239 376.947 178.276 376.947C177.135 376.947 176.127 376.7 175.254 376.206C174.38 375.694 173.702 374.962 173.221 374.009C172.739 373.056 172.498 371.936 172.498 370.648V362.02H177.046V370.039C177.046 371.027 177.304 371.795 177.821 372.342C178.339 372.889 179.034 373.162 179.908 373.162C180.799 373.162 181.504 372.889 182.021 372.342C182.538 371.795 182.797 371.027 182.797 370.039V362.02H187.371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.728 377C195.426 377 194.267 376.779 193.251 376.338C192.234 375.897 191.432 375.297 190.843 374.539C190.255 373.762 189.925 372.898 189.854 371.945H194.374C194.428 372.456 194.668 372.871 195.096 373.189C195.524 373.506 196.051 373.665 196.675 373.665C197.245 373.665 197.682 373.559 197.985 373.348C198.306 373.118 198.467 372.827 198.467 372.474C198.467 372.051 198.244 371.742 197.798 371.548C197.352 371.336 196.63 371.107 195.631 370.86C194.562 370.613 193.67 370.357 192.957 370.092C192.243 369.81 191.628 369.377 191.111 368.795C190.594 368.195 190.335 367.392 190.335 366.387C190.335 365.54 190.567 364.772 191.031 364.084C191.512 363.378 192.208 362.822 193.117 362.417C194.044 362.011 195.141 361.808 196.407 361.808C198.28 361.808 199.751 362.267 200.821 363.184C201.908 364.102 202.533 365.319 202.693 366.837H198.467C198.395 366.325 198.164 365.919 197.771 365.619C197.397 365.319 196.898 365.169 196.273 365.169C195.738 365.169 195.328 365.275 195.043 365.487C194.758 365.681 194.615 365.954 194.615 366.307C194.615 366.731 194.838 367.048 195.284 367.26C195.747 367.472 196.461 367.684 197.424 367.895C198.529 368.178 199.43 368.46 200.125 368.742C200.821 369.007 201.427 369.448 201.944 370.066C202.479 370.666 202.756 371.477 202.773 372.501C202.773 373.365 202.524 374.142 202.024 374.83C201.543 375.5 200.839 376.03 199.911 376.418C199.002 376.806 197.941 377 196.728 377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.872 360.485C207.07 360.485 206.41 360.255 205.893 359.796C205.393 359.32 205.144 358.738 205.144 358.05C205.144 357.344 205.393 356.762 205.893 356.303C206.41 355.826 207.07 355.588 207.872 355.588C208.657 355.588 209.299 355.826 209.798 356.303C210.315 356.762 210.574 357.344 210.574 358.05C210.574 358.738 210.315 359.32 209.798 359.796C209.299 360.255 208.657 360.485 207.872 360.485ZM210.146 362.02V376.788H205.572V362.02H210.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.555 361.861C224.303 361.861 225.694 362.425 226.728 363.555C227.78 364.666 228.306 366.201 228.306 368.16V376.788H223.759V368.769C223.759 367.781 223.5 367.013 222.983 366.466C222.466 365.919 221.77 365.646 220.897 365.646C220.023 365.646 219.327 365.919 218.81 366.466C218.293 367.013 218.035 367.781 218.035 368.769V376.788H213.46V362.02H218.035V363.978C218.498 363.325 219.122 362.814 219.907 362.443C220.692 362.055 221.574 361.861 222.555 361.861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.554 369.166C245.554 369.589 245.528 370.03 245.474 370.489H235.122C235.194 371.407 235.488 372.112 236.005 372.606C236.54 373.083 237.191 373.321 237.958 373.321C239.099 373.321 239.892 372.845 240.338 371.892H245.207C244.957 372.862 244.502 373.736 243.842 374.512C243.2 375.288 242.389 375.897 241.408 376.338C240.427 376.779 239.331 377 238.118 377C236.656 377 235.354 376.691 234.213 376.074C233.072 375.456 232.18 374.574 231.538 373.427C230.896 372.28 230.575 370.939 230.575 369.404C230.575 367.869 230.887 366.528 231.511 365.381C232.153 364.234 233.045 363.352 234.186 362.734C235.327 362.117 236.638 361.808 238.118 361.808C239.563 361.808 240.847 362.108 241.97 362.708C243.093 363.308 243.967 364.163 244.591 365.275C245.233 366.387 245.554 367.684 245.554 369.166ZM240.873 367.975C240.873 367.198 240.606 366.581 240.071 366.122C239.536 365.663 238.867 365.434 238.065 365.434C237.298 365.434 236.647 365.654 236.112 366.096C235.595 366.537 235.274 367.163 235.149 367.975H240.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.039 377C252.738 377 251.578 376.779 250.562 376.338C249.546 375.897 248.743 375.297 248.155 374.539C247.566 373.762 247.236 372.898 247.165 371.945H251.685C251.739 372.456 251.98 372.871 252.408 373.189C252.836 373.506 253.362 373.665 253.986 373.665C254.556 373.665 254.993 373.559 255.296 373.348C255.617 373.118 255.778 372.827 255.778 372.474C255.778 372.051 255.555 371.742 255.109 371.548C254.663 371.336 253.941 371.107 252.943 370.86C251.873 370.613 250.981 370.357 250.268 370.092C249.554 369.81 248.939 369.377 248.422 368.795C247.905 368.195 247.646 367.392 247.646 366.387C247.646 365.54 247.878 364.772 248.342 364.084C248.823 363.378 249.519 362.822 250.428 362.417C251.355 362.011 252.452 361.808 253.718 361.808C255.591 361.808 257.062 362.267 258.132 363.184C259.22 364.102 259.844 365.319 260.004 366.837H255.778C255.707 366.325 255.475 365.919 255.082 365.619C254.708 365.319 254.209 365.169 253.585 365.169C253.05 365.169 252.639 365.275 252.354 365.487C252.069 365.681 251.926 365.954 251.926 366.307C251.926 366.731 252.149 367.048 252.595 367.26C253.058 367.472 253.772 367.684 254.735 367.895C255.84 368.178 256.741 368.46 257.436 368.742C258.132 369.007 258.738 369.448 259.255 370.066C259.79 370.666 260.067 371.477 260.084 372.501C260.084 373.365 259.835 374.142 259.336 374.83C258.854 375.5 258.15 376.03 257.222 376.418C256.313 376.806 255.252 377 254.039 377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.955 377C267.653 377 266.494 376.779 265.477 376.338C264.461 375.897 263.659 375.297 263.07 374.539C262.482 373.762 262.152 372.898 262.08 371.945H266.601C266.654 372.456 266.895 372.871 267.323 373.189C267.751 373.506 268.277 373.665 268.901 373.665C269.472 373.665 269.909 373.559 270.212 373.348C270.533 373.118 270.693 372.827 270.693 372.474C270.693 372.051 270.471 371.742 270.025 371.548C269.579 371.336 268.857 371.107 267.858 370.86C266.788 370.613 265.897 370.357 265.183 370.092C264.47 369.81 263.855 369.377 263.338 368.795C262.82 368.195 262.562 367.392 262.562 366.387C262.562 365.54 262.794 364.772 263.257 364.084C263.739 363.378 264.434 362.822 265.344 362.417C266.271 362.011 267.368 361.808 268.634 361.808C270.506 361.808 271.977 362.267 273.047 363.184C274.135 364.102 274.759 365.319 274.92 366.837H270.693C270.622 366.325 270.39 365.919 269.998 365.619C269.624 365.319 269.124 365.169 268.5 365.169C267.965 365.169 267.555 365.275 267.27 365.487C266.984 365.681 266.842 365.954 266.842 366.307C266.842 366.731 267.065 367.048 267.51 367.26C267.974 367.472 268.687 367.684 269.65 367.895C270.756 368.178 271.656 368.46 272.352 368.742C273.047 369.007 273.654 369.448 274.171 370.066C274.706 370.666 274.982 371.477 275 372.501C275 373.365 274.75 374.142 274.251 374.83C273.77 375.5 273.065 376.03 272.138 376.418C271.228 376.806 270.167 377 268.955 377Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_638_58",
    x: 4,
    y: 103.357,
    width: 3,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_638_58"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_638_58",
    x: 3,
    y: 100.357,
    width: 10,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.121569 0 0 0 0 0.133333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_638_58"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_638_58",
    x: 347.627,
    y: 169.728,
    width: 3,
    height: 73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_638_58"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_638_58",
    x: 342.627,
    y: 166.728,
    width: 10,
    height: 79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.121569 0 0 0 0 0.133333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_638_58"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_638_58",
    x: 4,
    y: 153.735,
    width: 3,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_638_58"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_638_58",
    x: 3,
    y: 150.735,
    width: 10,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.121569 0 0 0 0 0.133333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_638_58"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_638_58",
    x: 4,
    y: 217.706,
    width: 3,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_638_58"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_638_58",
    x: 3,
    y: 214.706,
    width: 10,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.121569 0 0 0 0 0.133333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_638_58"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ii_638_58",
    x: 7.40576,
    y: 8,
    width: 344.816,
    height: 693.086,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_638_58"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_638_58",
    result: "effect2_innerShadow_638_58"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_638_58",
    x: -1.84825,
    y: 14.4873,
    width: 49.0046,
    height: 48.2119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_638_58"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_638_58",
    x: -2.65016,
    y: 639.628,
    width: 49.0047,
    height: 48.2119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_638_58"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_638_58",
    x: 308.966,
    y: 14.4873,
    width: 49.0046,
    height: 48.2109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_638_58"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_638_58",
    x: 309.367,
    y: 639.629,
    width: 49.0047,
    height: 48.2109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_638_58"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_ddddi_638_58",
    x: 0.0191956,
    y: 0.597656,
    width: 359.589,
    height: 704.891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.629167 0 0 0 0 0.629167 0 0 0 0 0.629167 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_638_58"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_638_58",
    result: "effect2_dropShadow_638_58"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_638_58",
    result: "effect3_dropShadow_638_58"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_638_58",
    result: "effect4_dropShadow_638_58"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_638_58",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect5_innerShadow_638_58"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_638_58",
    x: 14.4249,
    y: 14.9961,
    width: 326.777,
    height: 686.093,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_638_58"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_dii_638_58",
    x: 207.088,
    y: 32.1885,
    width: 8.81152,
    height: 8.79785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_638_58"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_638_58",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_638_58"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_638_58",
    result: "effect3_innerShadow_638_58"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_638_58",
    x: 156.167,
    y: 31.5889,
    width: 44.0959,
    height: 11.998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_638_58"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 0.124701,
    height: 1.25057
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_638_58",
    transform: "scale(0.00194845 0.0195401)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_638_58",
    transform: "matrix(0.00133333 0 0 0.000617522 0 -0.00142771)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_638_58",
    x1: 6,
    y1: 103.357,
    x2: 6,
    y2: 124.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_638_58",
    x1: 9,
    y1: 100.754,
    x2: 9,
    y2: 126.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030649,
    stopColor: "#201F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912771,
    stopColor: "#201F22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910238,
    stopColor: "#201F22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969904,
    stopColor: "#201F22",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_638_58",
    x1: 1,
    y1: 0,
    x2: 1,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_638_58",
    x1: 346.627,
    y1: 167.889,
    x2: 346.627,
    y2: 244.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030649,
    stopColor: "#201F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912771,
    stopColor: "#201F22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910238,
    stopColor: "#201F22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969904,
    stopColor: "#201F22",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_638_58",
    x1: 6,
    y1: 153.735,
    x2: 6,
    y2: 196.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_638_58",
    x1: 9,
    y1: 151.456,
    x2: 9,
    y2: 199.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030649,
    stopColor: "#201F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912771,
    stopColor: "#201F22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910238,
    stopColor: "#201F22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969904,
    stopColor: "#201F22",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_638_58",
    x1: 6,
    y1: 217.706,
    x2: 6,
    y2: 260.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_638_58",
    x1: 9,
    y1: 215.427,
    x2: 9,
    y2: 262.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030649,
    stopColor: "#201F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912771,
    stopColor: "#201F22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910238,
    stopColor: "#201F22",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969904,
    stopColor: "#201F22",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_638_58",
    x1: 7.40576,
    y1: 8,
    x2: 346.66,
    y2: 698.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612097,
    stopColor: "#595560",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_638_58",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(348.221 7.99999) rotate(139.985) scale(248.415 122.276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171212",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_638_58",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.1175 644.91) rotate(128.678) scale(58.3848 28.7707)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.719628,
    stopColor: "#EAE7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C3B1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_638_58",
    x1: 219.742,
    y1: 35.588,
    x2: 211.518,
    y2: 27.3397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393056,
    stopColor: "#232426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_638_58",
    x1: 204.841,
    y1: 36.4717,
    x2: 212.845,
    y2: 43.7238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopOpacity: 0.5001
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_638_58",
    x1: 210.291,
    y1: 33.7031,
    x2: 214.916,
    y2: 38.8568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_638_58",
    x1: 209.088,
    y1: 33.1885,
    x2: 209.088,
    y2: 37.9863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#062F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#012576"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_638_58",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(211.729 35.5874) rotate(119.529) scale(1.80213 5.71212)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856633,
    stopColor: "#010D1E",
    stopOpacity: 0.13912
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010B17",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_638_58",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(212.093 34.2479) rotate(125.991) scale(1.01837 1.74685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C84FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C85AD",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_638_58",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.769 35.1276) rotate(90) scale(1.01537 1.01827)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_638_58",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(213.9 36.3984) rotate(22.2021) scale(1.19947 1.50991)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C86FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3901,
    stopColor: "#0A9DFF",
    stopOpacity: 0.371533
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ABFF",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_638_58",
    x1: 209.088,
    y1: 33.1885,
    x2: 209.088,
    y2: 37.9863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5200FF",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B800FF",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_638_58",
    x1: 158.167,
    y1: 35.588,
    x2: 198.262,
    y2: 35.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_638_58",
    x1: 178.214,
    y1: 38.1868,
    x2: 178.214,
    y2: 32.9891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_638_58",
    x1: 16.2269,
    y1: 609.901,
    x2: 29.8966,
    y2: 609.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_638_58",
    x1: 340.555,
    y1: 612.157,
    x2: 327.391,
    y2: 612.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_638_58",
    x1: 71.8,
    y1: 110.324,
    x2: 352.551,
    y2: 822.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73F580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.20768,
    height: 27.1876,
    fill: "white",
    transform: "translate(5 100.357)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_638_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.20767,
    height: 79.1639,
    fill: "white",
    transform: "matrix(-1 0 0 1 350.627 166.728)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_638_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.20768,
    height: 48.7778,
    fill: "white",
    transform: "translate(5 150.735)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_638_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.20768,
    height: 48.7778,
    fill: "white",
    transform: "translate(5 214.706)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_638_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.6998,
    height: 5.59745,
    fill: "white",
    transform: "translate(157.365 32.7891)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_638_58",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAA40lEQVR4Xu3bQQ6EQAhEUbj/oXsO8Sdh4XOvJAi/qkF3Zt6E6710++xuiD6T40uACtACqYlzD2IACFKBkoHcgmSQDJJBMngKIT6ADygF6DSYfcCLTzg/z0eGrASogDbT0gKxB2MB5pkiBoBgrEEMwIBjLx9fAAiCIAhygmkkRgYjhWMHditsL2AvYC+QIHjdwzk+BmAABmBAWc1kCF0bKRAEQRAEQRAMGaACbaCUz/P5BRiKxhQaiV07uRjfYgQDMKDpGAhGCMUCzD4CBEEw1iAGYIBPZMJh+g8/P8cKpAJfV4EfMee/sLtaEFIAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_638_58",
    width: 750,
    height: 1624,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAu4AAAZYAQMAAADzD9XyAAAABlBMVEUkJCQpKSkTIzWqAAACeUlEQVR4Ae3ZpxVCUQAFwSVIUkdQOnQEnlTCj3LsC+Pv2U3V9V6vS+3e1WbNAzwej8fj8Xg8Ho8fy/+qx63Oz/rsqzUPDng8Ho/H4/F4PB4/ljfd8Hg8Ho/H4/F4vHaCx+PxeDwej8fj8doJHo/H4/F4PB6P107weDwej8fj8Xg8XjvB4/F4PB6Px+Px2gkej8fj8Xg8Ho/Hayd4PB6Px+PxeDxeO8Hj8Xg8Ho/H4/F47QSPn87j8Xg8Ho/H47UTPB6Px+PxeDwejzfd8Hg8Ho/H4/F4vHaCx+PxeDwej8fj8doJHo/H4/F4PB6P107weDwej8fj8Xg8XjvB4/F4PB6Px+Px2gkej8fj8Xg8Ho/Hayd4PB6Px+PxeDxeO8Hj8Xg8Ho/H4/F47QSPn87j8Xg8Ho/H47UTPB6Px+PxeDwejzfd8Hg8Ho/H4/F4vHaCx+PxeDwej8fj8doJHo/H4/F4PB6P107weDwej8fj8Xg8XjvB4/F4PB6Px+Px2gkej8fj8Xg8Ho/Hayd4PB6Px+PxeDxeO8Hj8Xg8Ho/H4/F47QSPx+PxeDwej8dP1bQTPB6Px+PxeDwej9dO8Hg8Ho/H4/F4vHaCx+PxeDwej8fj8doJHo/H4/F4PB6P107weDwej8fj8Xg8XjvB4/F4PB6Px+Px2gkej8fj8Xg8Ho/Hayd4PB6Px+Px+EEej9dO8Hg8Ho/H4/F4PF47wePxeDwej8fj8doJHo/H4/F4PB6Px2sneDwej8fj8Xg8XjvB4/F4PB6Px+PxeO0Ej8fj8Xg8Ho/Hayd4PB6Px+PxeDwer53g8Xg8Ho/H4/H4Zbx2gsfj8Xg8Ho//A/r/oG7T9gGDAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.985b7d8e13eee8085dbb89401cda10c4.svg";
export { ForwardRef as ReactComponent };